import React, { useCallback, useMemo } from 'react';
import { Checkbox } from '@mui/material';
import { TimeSignal } from 'graphql/types';
import { useFeatureFlag } from 'modules/common/hooks';
import { useNotesItemHeaderCheckActions } from './hooks/useNotesItemHeaderCheckActions';

type NoteListGroupHeaderCheckboxProps = {
  groupKey: string;
  notes: TimeSignal[];
  totalCount: number;
  ariaLabelMsg?: string;
};

export const NotesListGroupHeaderCheckbox: React.FC<NoteListGroupHeaderCheckboxProps> = ({
  groupKey,
  notes,
  totalCount,
  ariaLabelMsg
}: NoteListGroupHeaderCheckboxProps) => {
  const { indeterminate, selectAll, onChange } = useNotesItemHeaderCheckActions(
    {
      notes,
      watchId: groupKey,
      totalCount
    }
  );

  const isTiwScreenReaderEnabled = useFeatureFlag('isTiwScreenReaderEnabled');

  const inputProps = useMemo(
    () => ({
      inputProps: {
        'data-testid': `notes-list-group-header-clickable-checkbox_${groupKey}`,
        'aria-label': isTiwScreenReaderEnabled ? ariaLabelMsg : ''
      } as any
    }),
    [ariaLabelMsg, groupKey, isTiwScreenReaderEnabled]
  );
  const stopPropogationClick = useCallback(
    (event: any) => event.stopPropagation(),
    []
  );

  return (
    <Checkbox
      data-testid={`notes-list-group-header-select-checkbox_${groupKey}`}
      color="default"
      checked={selectAll}
      indeterminate={indeterminate}
      onChange={onChange}
      onClick={stopPropogationClick}
      {...inputProps}
    />
  );
};
